<!-- packages/studio/src/components/army/UnitStatsForm.vue -->
<template>
  <div class="unit-stats">
    <div class="stat-grid">
      <StField label="Move"
        ><StTextInput
          :model-value="modelValue.move ?? ''"
          @update:model-value="patch({ move: $event || null })"
      /></StField>
      <StField label="Health"
        ><StTextInput
          :model-value="modelValue.health"
          @update:model-value="patch({ health: $event ?? '' })"
      /></StField>
      <StField label="Control"
        ><StTextInput
          :model-value="modelValue.control ?? ''"
          @update:model-value="patch({ control: $event || null })"
      /></StField>
      <StField label="Save"
        ><StTextInput
          :model-value="modelValue.save"
          @update:model-value="patch({ save: $event ?? '' })"
      /></StField>
      <StField label="Ward"
        ><StTextInput
          :model-value="modelValue.ward ?? ''"
          @update:model-value="patch({ ward: $event || null })"
      /></StField>
      <StField label="Banishment"
        ><StTextInput
          :model-value="modelValue.banishment ?? ''"
          @update:model-value="patch({ banishment: $event || null })"
      /></StField>
      <StField label="Points"
        ><StNumberInput
          :model-value="modelValue.points"
          @update:model-value="patch({ points: $event ?? 0 })"
      /></StField>
    </div>

    <section class="form-section">
      <div class="st-eyebrow">Weapons</div>
      <UnitWeaponsForm :model-value="weapons" @update:model-value="onWeapons" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { IUnit, IWeapon } from '@scrolldex/shared';
import { unitWeapons, withUnitWeapons } from '@scrolldex/shared';
import UnitWeaponsForm from './UnitWeaponsForm.vue';
import { StField, StTextInput, StNumberInput } from '../ui/index.js';

const props = defineProps<{ modelValue: IUnit }>();
const emit = defineEmits<{ (e: 'update:modelValue', value: IUnit): void }>();

const weapons = computed<IWeapon[]>(() => unitWeapons(props.modelValue));

function patch(part: Partial<IUnit>) {
  emit('update:modelValue', { ...props.modelValue, ...part });
}
function onWeapons(next: IWeapon[]) {
  emit('update:modelValue', withUnitWeapons(props.modelValue, next));
}
</script>

<style scoped>
.unit-stats {
  display: flex;
  flex-direction: column;
  gap: var(--st-space-4);
}
.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--st-space-2);
}
.form-section {
  display: flex;
  flex-direction: column;
  gap: var(--st-space-2);
}
</style>
